<h2 mat-dialog-title>Mes paramètres personnels</h2>

<mat-dialog-content>
  <mat-form-field class="full-width">
    <mat-label>Stations</mat-label>
    <mat-select [(ngModel)]="stationsSelected" multiple>
      <mat-option *ngFor="let station of stations" [value]="station.id">
        {{ station.label }}
      </mat-option>
    </mat-select>
  </mat-form-field>

  <mat-form-field class="full-width">
    <mat-label>Catégorie Sons</mat-label>
    <mat-select [(ngModel)]="categorieSelected">
      <mat-option [value]="null">— Aucune (défaut) —</mat-option>
      <mat-option *ngFor="let cat of categories" [value]="cat.id">
        {{ cat.label }}
      </mat-option>
    </mat-select>
  </mat-form-field>

  <div *ngIf="hasNickname" style="margin-top: 8px;">
    <mat-slide-toggle [(ngModel)]="preferNickname">
      Préférer l'utilisation du Surnom si défini
    </mat-slide-toggle>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="cancel()">Annuler</button>
  <button mat-button color="warn" (click)="reset()">Réinitialiser</button>
  <button mat-raised-button color="primary" (click)="save()">Sauvegarder</button>
</mat-dialog-actions>
